import { render, staticRenderFns } from "./SuggestedPlan.vue?vue&type=template&id=25a1e70a&"
import script from "./SuggestedPlan.vue?vue&type=script&lang=js&"
export * from "./SuggestedPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports